<template>
    <div style="padding-left: 10px;padding-right: 10px;height: 100%">
        <sjj-editor-sql v-if="isJXSql"></sjj-editor-sql>
    </div>
</template>

<script>
    import SjjEditorSql from "./sjjEditorSql";
    export default {
        name: "sjjEditor",
        components: {SjjEditorSql},
        methods: {
            // 是否是SQL数据集
            isJXSql: function () {
                return this.$comUtils.isEmpty(this.$route.query.tableName);
            }
        }
    }
</script>
<style scoped>
</style>
